export const formatNumber = (number) => {
  return new Intl.NumberFormat('ru-RU', { notation: 'compact', minimumFractionDigits: 1, maximumFractionDigits: 2 }).format(number);
};
